import {EditEquipment} from "./EditEquipment";
import {AutogenLayoutPlanningCommentsQuickInfo} from "./autogen/AutogenLayoutPlanningCommentsQuickInfo";
import {ClickEvent, DataDisplayEvent} from "@mcleod/components";
import { getDispatchControlValue } from "@mcleod/general";

export class PlanningCommentsQuickInfo extends AutogenLayoutPlanningCommentsQuickInfo {
    private dcMaxTrailers = getDispatchControlValue("maximum_trailers");

    /** This is an event handler for the onClick event of buttonAddComments. */
    buttonAddCommentsOnClick(event: ClickEvent) {
        EditEquipment.showSlideout({
            driverName: this.activeRow.get("driver1_name"),
            driverId: this.activeRow.get("driver1_id"),
            driver2Name: this.activeRow.get("driver2_name"),
            driver2Id: this.activeRow.get("driver2_id"),
            tractorId: this.activeRow.get("tractor"),
            trailerId: this.activeRow.get("trailer"),
            trailer2Id: this.activeRow.get("trailer2"),
            trailer3Id: this.activeRow.get("trailer3"),
            orderId: this.activeRow.get("order_id")
        });
    }

    /** This is an event handler for the onDisplay event of sourceEquipMove. */
    sourceEquipMoveOnDisplay(event: DataDisplayEvent) {
        const data = event.rowData;
        const hasCommentDriver1 = !data.isNull("driver1_planning_comment");
        const hasCommentDriver2 = !data.isNull("driver2_planning_comment");
        const hasCommentTractor = !data.isNull("tractor_planning_comment");
        const hasCommentTrailer2 = !data.isNull("trailer2_planning_comment");
        const hasCommentTrailer3 = !data.isNull("trailer3_planning_comment");
        const hasCommentTrailer = !data.isNull("trailer_planning_comment");
        const hasCommentOrder = !data.isNull("planning_comment");

        const driverId: string = this.activeRow.get("driver1_id", null);
        if (!hasCommentDriver1 || driverId === null) {
            this.labelDriver.visible = false;
        } else {
            const driverName: string = this.activeRow.get("driver1_name", null);
            this.labelDriver.text = `Driver 1 (${driverName ?? driverId}) Planning Comment`;
        }

        const driver2Id: string = this.activeRow.get("driver2_id", null);
        if (!hasCommentDriver2 || driver2Id === null) {
            this.labelDriver2.visible = false;
        } else {
            const driver2Name: string = this.activeRow.get("driver2_name", null);
            this.labelDriver2.text = `Driver 2 (${driver2Name ?? driver2Id}) Planning Comment`;
        }

        const tractorId: string = this.activeRow.get("tractor", null);
        if (!hasCommentTractor || tractorId === null) {
            this.labelTractor.visible = false;
        } else {
            this.labelTractor.text = `Tractor (${tractorId}) Planning Comment`;
        }

        const trailerId: string = this.activeRow.get("trailer", null);
        if (!hasCommentTrailer || trailerId === null) {
            this.labelTrailer.visible = false;
        } else {
            this.labelTrailer.text = `Trailer 1 (${trailerId}) Planning Comment`;
        }



        if (this.dcMaxTrailers >= 2) {
            // Trailer 2
            this.labelTrailer2.visible = true;
            this.textboxTrailer2Comment.visible = true;
            if (this.dcMaxTrailers >= 3) {
                // Trailer 3
                this.labelTrailer3.visible = true;
                this.textboxTrailer3Comment.visible = true;
            }
        }

        const trailer2Id: string = this.activeRow.get("trailer2", null);
        if (!hasCommentTrailer2 || trailer2Id === null) {
            this.labelTrailer2.visible = false;
        } else {
            this.labelTrailer2.text = `Trailer 2 (${trailer2Id}) Planning Comment`;
        }

        const trailer3Id: string = this.activeRow.get("trailer3", null);
        if (!hasCommentTrailer3 || trailer3Id === null) {
            this.labelTrailer3.visible = false;
        } else {
            this.labelTrailer3.text = `Trailer 3 (${trailer3Id}) Planning Comment`;
        }

        const orderId: string = this.activeRow.get("order_id", null);
        if (!hasCommentOrder || orderId === null) {
            this.labelOrder.visible = false;
        } else {
            this.labelOrder.text = `Order (${orderId}) Planning Comment`;
        }
    }
}
